var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.398 11.75C9.97279 11.75 9.6249 12.0875 9.6249 12.5V14H1.54617V2H9.6249V3.5C9.6249 3.9125 9.97279 4.25 10.398 4.25C10.8232 4.25 11.1711 3.9125 11.1711 3.5V2C11.1711 1.175 10.4753 0.5 9.6249 0.5H1.54617C0.695776 0.5 0 1.175 0 2V14C0 14.825 0.695776 15.5 1.54617 15.5H9.6249C10.4753 15.5 11.1711 14.825 11.1711 14V12.5C11.1711 12.0875 10.8232 11.75 10.398 11.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3891 7.47504L13.2001 4.41879C13.0455 4.28754 12.8329 4.23129 12.6396 4.25004C12.427 4.26879 12.2531 4.36254 12.1178 4.51254C11.8665 4.79379 11.8859 5.20629 12.1564 5.52504L13.9732 7.26879H6.26168C5.83649 7.26879 5.4886 7.60629 5.4886 8.01879C5.4886 8.43129 5.83649 8.76879 6.26168 8.76879H13.9539L12.1758 10.4563C12.0212 10.5875 11.9245 10.775 11.9052 10.9625C11.8859 11.1688 11.9439 11.3563 12.0791 11.5063C12.2144 11.6563 12.4077 11.75 12.601 11.7688C12.6203 11.7688 12.6396 11.7688 12.659 11.7688C12.8329 11.7688 13.0262 11.7125 13.1615 11.6C13.2001 11.5813 13.2194 11.5438 13.2194 11.5438L16.3698 8.52504C16.5244 8.37504 16.6017 8.18754 16.6017 8.00004C16.621 7.79379 16.5437 7.60629 16.3891 7.47504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.0aca533f970859657c40cfce16da5f65.svg";
export { ForwardRef as ReactComponent };